import React from "react";
import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { PayOnAccountDialog } from "../routes/_site.dashboard.invoices.route/PayOnAccountDialog";
import { ReplaceIfExtension } from "@core/components/PipelineComponents/ReplaceIfExtension";
import { useRootLoaderData } from "@/root";
import { InvoicingConfigSection } from "@/apidtos";

const PayOnAccountDialogExtension: React.FC = () => {
  const { config } = useRootLoaderData();
  const invoicingConfig = config?.Invoicing as InvoicingConfigSection | undefined;
  if (!invoicingConfig?.AllowPayOnAccount) return null;

  return (
    <ReplaceIfExtension name="site.dashboard.invoices-and-credits.payOnAccountDialog">
      <PayOnAccountDialog />
    </ReplaceIfExtension>
  );
};

registerExtension(
  "site.dashboard.invoices-and-credits.beforeGrid",
  PayOnAccountDialogExtension,
  "PayOnAccountDialogExtension"
);
